import React, { useState } from 'react';
import './ExpenseModal.css';

const ExpenseModal = ({ isOpen, onClose, onSubmit }) => {
  const defaultDate = new Date().toISOString().split('T')[0];
  
  const [expense, setExpense] = useState({
    date: defaultDate,
    amount: '',
    category: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(expense);
    setExpense({
      date: defaultDate,
      amount: '',
      category: ''
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Track New Expense</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Date:</label>
            <input
              type="date"
              value={expense.date}
              onChange={(e) => setExpense({...expense, date: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>Amount (₹):</label>
            <input
                type="number"
                value={expense.amount}
                onChange={(e) => setExpense({...expense, amount: parseInt(e.target.value, 10)})}
                placeholder="Enter amount"
                required
            />

          </div>

          <div className="form-group">
            <label>Category:</label>
            <input
              type="text"
              value={expense.category}
              onChange={(e) => setExpense({...expense, category: e.target.value})}
              placeholder="Enter category (e.g., Food, Transport)"
              required
            />
          </div>

          <div className="modal-buttons">
            <button type="submit">Save Expense</button>
            <button type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExpenseModal;
